__webpack_require__.p = "https://fr-investment-fe.sandbox.securitize.io/";